import type { CSSProperties } from "react"
import { Separator } from "@workspace/ui/components/separator"
import { useI18n } from "@/lib/i18n"
import { ProductCard } from "./product-card"

const delay = (n: number) => ({ "--d": n } as CSSProperties)

export function Products() {
  const { t } = useI18n()

  return (
    <section
      id="products"
      className="relative border-t border-border py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-14 xl:px-20">
        {/* Editorial numbered heading */}
        <header className="rise-stagger flex items-center gap-5">
          <h2
            style={delay(0)}
            className="flex items-baseline gap-3 text-2xl font-semibold tracking-[-0.02em] md:text-3xl"
          >
            <span className="font-mono text-sm font-normal text-primary">02.</span>
            <span className="text-foreground">{t.products.eyebrow}</span>
          </h2>
          <Separator
            style={delay(1)}
            className="h-px flex-1 bg-foreground/20"
          />
        </header>

        {/* Title + lead */}
        <div className="rise-stagger mt-12 grid grid-cols-12 gap-x-6 gap-y-6">
          <h3
            style={delay(2)}
            className="col-span-12 text-[clamp(1.9rem,4.2vw,3.3rem)] leading-[1.05] font-extrabold tracking-[-0.03em] text-foreground md:col-span-8"
          >
            {t.products.title}
          </h3>
          <p
            style={delay(3)}
            className="col-span-12 text-[15px] leading-[1.7] text-foreground/65 md:col-span-10 md:text-lg"
          >
            {t.products.lead}
          </p>
        </div>

        {/* Cards */}
        <div className="rise-stagger mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.products.items.map((item, i) => (
            <ProductCard
              key={item.label}
              index={i}
              number={String(i + 1).padStart(2, "0")}
              variant={item.href ? "default" : "muted"}
              {...item}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
